import React, { useState, useEffect } from 'react'
import * as styles from './password-gate.module.css'
import favicon from '../../img/favicon.png'

const PasswordGate = ({ children }) => {
  const shouldProtect = process.env.GATSBY_PASSWORD_PROTECT === 'true'
  const storedAuth = typeof window !== 'undefined' && localStorage.getItem('previewAuth')

  const [isAuthenticated, setIsAuthenticated] = useState(!shouldProtect || storedAuth === 'true')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(false)

  useEffect(() => {
    // Sync state on mount in case env vars or localStorage changed
    if (!shouldProtect || storedAuth === 'true') {
      setIsAuthenticated(true)
    }
  }, [])

  const handleSubmit = e => {
    e.preventDefault()
    const correctPassword = process.env.GATSBY_PREVIEW_PASSWORD

    if (password === correctPassword) {
      setIsAuthenticated(true)
      localStorage.setItem('previewAuth', 'true')
      setError(false)
    } else {
      setError(true)
      setPassword('')
    }
  }

  if (isAuthenticated) {
    return children
  }

  return (
    <>
      <div>
        <div>
          <div>
            <div className={styles.gateContainer}>
              <div className={styles.gateContent}>
                <img src={favicon} alt="Redpoint" className={styles.logo} />
                <h1 className={styles.passwordTitle}>Staging Access</h1>
                <p className={styles.description}>
                  This is a preview deployment. Please enter the password to continue.
                </p>

                <form onSubmit={handleSubmit} className={styles.form}>
                  <div className={styles.inputGroup}>
                    <input
                      type="password"
                      placeholder="Enter password"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                      className={styles.input}
                      autoFocus
                    />
                  </div>

                  {error && <p className={styles.error}>Incorrect password. Please try again.</p>}

                  <button type="submit" className={styles.button}>
                    Access Staging
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PasswordGate
